@if (showMsg) {
  <!-- Full-width banner layout (no mat-card overflow) 20/07/2026 DW -->
  <div class="general-response-banner" data-notify="container">
    <span class="general-response-banner__message" data-notify="message">
      {{ message }}
    </span>
    <button
      type="button"
      class="general-response-banner__close"
      aria-label="Close message"
      (click)="hideMessage()"
    >
      ×
    </button>
  </div>
}
